import { Modal, Input, Button, Tooltip } from "antd";

interface FileUploadModalsProps {
  // Same name modal
  sameNameModalOpen: boolean;
  onCloseSameNameModal: () => void;
  newFileName: string;
  onFileNameChange: (value: string) => void;
  isNewFileNameTaken: boolean;
  currentFile: File | null;
  onRenameAndUpload: () => void;
  uploading: boolean;

  // Same hash modal
  sameHashModalOpen: boolean;
  onCloseSameHashModal: () => void;
  sameHashModalFiles: any[];
  onContinueUpload: () => void;
}

export const FileUploadModals = ({
  sameNameModalOpen,
  onCloseSameNameModal,
  newFileName,
  onFileNameChange,
  isNewFileNameTaken,
  currentFile,
  onRenameAndUpload,
  uploading,
  sameHashModalOpen,
  onCloseSameHashModal,
  sameHashModalFiles,
  onContinueUpload
}: FileUploadModalsProps) => {
  const getFileNameWithoutExtension = (fileName: string) => {
    return fileName.includes(".")
      ? fileName.substring(0, fileName.lastIndexOf("."))
      : fileName;
  };

  return (
    <>
      {/* Same Name Modal */}
      <Modal
        open={sameNameModalOpen}
        onCancel={onCloseSameNameModal}
        footer={[
          <Button
            key="back"
            onClick={onCloseSameNameModal}
            style={{ color: "white" }}
          >
            Cancel
          </Button>,
          <Tooltip
            key="submit-tooltip"
            title={
              !newFileName || newFileName.trim() === ""
                ? "Please enter a new file name"
                : newFileName === currentFile?.name
                  ? "Please choose a different name than the original"
                  : isNewFileNameTaken
                    ? "This filename is already taken"
                    : ""
            }
          >
            <Button
              key="submit"
              loading={uploading}
              disabled={
                !newFileName ||
                newFileName.trim() === "" ||
                newFileName === currentFile?.name ||
                isNewFileNameTaken
              }
              onClick={onRenameAndUpload}
              style={{
                color:
                  !newFileName ||
                  newFileName.trim() === "" ||
                  newFileName === currentFile?.name ||
                  isNewFileNameTaken
                    ? "black"
                    : "white"
              }}
            >
              Upload with new name
            </Button>
          </Tooltip>
        ]}
      >
        <p className="font-bold">
          File name already exists! Please rename your file.
        </p>
        <p>Enter a new name (extension will be preserved automatically):</p>
        <Input
          placeholder="New file name without extension"
          value={
            newFileName
              ? getFileNameWithoutExtension(newFileName)
              : currentFile?.name
                ? getFileNameWithoutExtension(currentFile.name)
                : ""
          }
          onChange={(e) => onFileNameChange(e.target.value)}
        />
        {isNewFileNameTaken && (
          <div style={{ color: "red", marginTop: "8px" }}>
            This filename is already taken. Please choose another name.
          </div>
        )}
      </Modal>

      {/* Same Hash Modal */}
      <Modal
        open={sameHashModalOpen}
        onCancel={onCloseSameHashModal}
        footer={[
          <Button
            key="back"
            onClick={onCloseSameHashModal}
            style={{ color: "white" }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            loading={uploading}
            onClick={onContinueUpload}
            style={{ color: "white" }}
          >
            Continue
          </Button>
        ]}
      >
        <p className="font-bold">File content matches the below file(s)!</p>
        {sameHashModalFiles.map((file, i) => (
          <p key={i}>{file.file_name}</p>
        ))}
        <p className="font-bold mt-10">
          Are you sure you want to continue uploading this file?
        </p>
      </Modal>
    </>
  );
};
